import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ token, css }: any) => ({
  section: css`
    background: ${token.ColorFigmaNeutralGrayscaleGray10};
  `,
  body: css`
    padding-top: 0;
  `,
  hidden: css`
    visibility: hidden;
  `,
}));

export const useItemsStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
